// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__z18HQ","inputWrap":"Table_inputWrap__2mEjs","col":"Table_col__35ynq","bmiTooltip":"Table_bmiTooltip__1X_Bv"};